"use client";

import { c as _c } from "react/compiler-runtime";
export default function HeroHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="tw-max-w-xl tw-px-4 tw-pt-10 md:tw-mx-auto md:tw-max-w-3xl md:tw-px-6 md:tw-text-center lg:tw-px-8"><p className="tw-mx-auto tw-mb-2 tw-text-balance tw-text-xs tw-uppercase tw-tracking-[0.2em] tw-text-iron-500">6529</p><h1 className="tw-mb-3 tw-text-balance tw-text-3xl tw-font-semibold tw-leading-tight tw-tracking-tight tw-text-iron-100 md:tw-text-4xl">Building a decentralized network state</h1></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}